var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.imageData)?_c('div',[_c('img',{attrs:{"width":"100%","src":_vm.imageData.image}})]):_vm._e(),_vm._v(" "),(_vm.error)?_c('mdb-card',{staticClass:"mb-4"},[_c('mdb-card-body',[_c('error',{attrs:{"error":_vm.error}})],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }